import {createSlice} from "@reduxjs/toolkit";
import {storage} from './Storage';
import {ContactorTypeDict, WeChatOrganizationTypeDict} from "../config/MerchantType";
import _ from 'lodash';

const MERCHANT_STATE = 'merchant';
const merchantSlice = createSlice({
    name: MERCHANT_STATE,
    initialState: {
        name: '',
        merchantId: 0,
        avatar: '',
        roles: [],
        merchantFansCount: 0,
        fansCount: 0,
        platformAccountId: 0,
        userFansCount: 0,
        subAccountId: 0,
        storeId: 0,
        mobile: '',
        merchants: [],
        manageMerchantCount: 1,
        currentPage: 1,
        totalPage: 0,
        address: {
            addressId: 0,
            name: '',
            consigneeMobile: '',
            consigneeName: '',
            addressDetail: '',
            lng: null,
            lat: null,
            province: '',
            provinceCode: '',
            city: '',
            cityCode: '',
            area: '',
            areaCode: '',
        },
        salesInfo: {
            runningGbCount: 0,
            runningContractCount: 0,
            todaySaleAmount: '0.00'
        },
        salesTrendInfo: {
            statisticType: '',
            statisticTimes: [],
            statisticItems: [],
        },
        subMerchantMaterialInfo: {
            focus: '',
            readContract: false,
            organizationType: WeChatOrganizationTypeDict.MICRO_SUB_MERCHANT,
            ownerRealName: '',
            ownerIdCardNumber: '',
            ownerIdCardAddress: '',
            ownerIdCardValidTimeBegin: null,
            ownerIdCardValidTimeEnd: null,
            ownerIdCardFrontPhoto: '',
            ownerIdCardBackPhoto: '',
            merchantShortName: '',
            companyName: '',
            businessLicenseNumber: '',
            businessLicensePhoto: '',
            ownerIdCardValidation: null,
            contactorIdCardFrontPhoto: '',
            contactorIdCardBackPhoto: '',
            contactorIdCardValidation: null,
            contactorIdCardValidTimeBegin: null,
            contactorIdCardValidTimeEnd: null,
            contactorAgentLicensePhoto: '',
            contactorType: ContactorTypeDict.CORPORATION,
            contactorRealName: '',
            contactorIdCardNumber: '',
            contactorMobilePhoneNumber: '',
            contactorEmail: '',
            bindBankAccountType: null,
            openAccountName: '',
            openAccountBank: '',
            bankAccountNumber: '',
            bankAddressCodes: null,
            bankAddressCode: '',
            submit: false,
            benefitIsSelf: true,
            benefitPersonList: [],
            status: 0,
            step: 0,
            maxStep: 0,
            requestNo: '',
            wxRequestNo: '',
            creatorQRCode: '',
            legalQRCode: '',
            errors: [],
            rejections: {},
        },
    },
    reducers: {
        setMerchant: (state, action) => {
            state.name = action.payload['name'];
            state.merchantId = action.payload['merchantId'];
            state.avatar = action.payload['avatar'];
            state.roles = action.payload['roles'];
            state.fansCount = action.payload['fansCount'];
            state.userFansCount = action.payload['userFansCount'];
            state.merchantFansCount = action.payload['merchantFansCount'];
            storage.set(MERCHANT_STATE, {
                name: state.name,
                merchantId: state.merchantId,
                avatar: state.avatar,
                roles: state.roles
            });
        },
        setSubMerchantMaterialInfo: (state, action) => {
            for (const key in  state.subMerchantMaterialInfo) {
                if (action.payload.hasOwnProperty(key)) {
                    state.subMerchantMaterialInfo[key] = action.payload[key];
                }
            }
        },
        setSalesInfo: (state, action) => {
            state.salesInfo.runningGbCount = action.payload['gb_num'];
            state.salesInfo.runningContractCount = action.payload['contract_num'];
            state.salesInfo.todaySaleAmount = action.payload['total_amount'];
        },
        resetMerchant: (state) => {
            state.name = '';
            state.merchantId = 0;
            state.avatar = '';
            state.roles = [];
        },
        initMerchant: (state) => {
            let merchant = storage.get(MERCHANT_STATE);
            state.name = merchant.name;
            state.merchantId = merchant.merchantId;
            state.avatar = merchant.avatar;
            state.roles = merchant.roles !== undefined ? merchant.roles : [];
        },
        setManageMerchant: (state, action) => {
            state.merchants = action.payload['merchants'];
            state.currentPage = action.payload['currentPage'];
            state.manageMerchantCount = action.payload['manageMerchantCount'];
            state.totalPage = action.payload['totalPage'];
            state.merchants.forEach((merchant) => {
                if (merchant.merchantId === state.merchantId) {
                    merchant.isCurrentMerchant = true;
                } else {
                    merchant.isCurrentMerchant = false;
                }
            });
        }
    }
});

const {setMerchant, resetMerchant, initMerchant, setManageMerchant, setSalesInfo, setSubMerchantMaterialInfo} = merchantSlice.actions;
const merchantState = (state) => {
    return _.isFunction(state) ? state(MERCHANT_STATE) : state[MERCHANT_STATE];
}


const merchantSelector = (state) => {
    return merchantState(state);
}

const subMerchantMaterialInfoSelector = (state) => {
    return merchantState(state).subMerchantMaterialInfo;
}

const getMerchantInfo = (state) => {
    return merchantState(state);
}

export {
    merchantSlice,
    setManageMerchant,
    setMerchant,
    resetMerchant,
    initMerchant,
    merchantSelector,
    MERCHANT_STATE,
    getMerchantInfo,
    setSalesInfo,
    subMerchantMaterialInfoSelector,
    setSubMerchantMaterialInfo
};
export default merchantSlice.reducer;